import {Construtor} from './construtor';

export class AgendaRoteiroProcesso implements Construtor<AgendaRoteiroProcesso> {

  public idAgendaRoteiroProcesso: number;
  public idAgendaRoteiroPontoFisico: number;
  public idProcessoSetor: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (AgendaRoteiroProcesso)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(indicadorProcesso: any): void {
    this.idAgendaRoteiroProcesso = indicadorProcesso.idAgendaRoteiroProcesso;
    this.idProcessoSetor = indicadorProcesso.idProcessoSetor;
    this.idAgendaRoteiroPontoFisico = indicadorProcesso.idAgendaRoteiroPontoFisico;
  }

  copyObject(indicadorProcesso: AgendaRoteiroProcesso): void {
    this.idAgendaRoteiroProcesso = indicadorProcesso.idAgendaRoteiroProcesso;
    this.idProcessoSetor = indicadorProcesso.idProcessoSetor;
    this.idAgendaRoteiroPontoFisico = indicadorProcesso.idAgendaRoteiroPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idProcessoSetor !== undefined && this.idAgendaRoteiroPontoFisico !== undefined;
  }

  getNewInstance(object?: any): AgendaRoteiroProcesso {
    return new AgendaRoteiroProcesso(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/agenda-roteiro-processo.ts